import { PageRequest } from '@/core/request/PageRequest';

export interface PurchaseGroupingFormValues {
  companyId: number;
  supplier: {
    id: number;
    name: string;
  };
  documentTypeId?: number;
}

export enum PurchasingGroupOrderColumn {
  CODE = 'CODE',
  ISSUE_DATE = 'ISSUE_DATE',
  DOCUMENT_NUMBER = 'DOCUMENT_NUMBER',
}

export enum PurchasingGroupFieldOption {
  code = 'code',
  issueDate = 'issueDate',
  documentNumber = 'documentNumber',
}

export const PurchasingGroupColumnConfig: Record<
  string,
  PurchasingGroupOrderColumn
> = {
  [PurchasingGroupFieldOption.code]: PurchasingGroupOrderColumn.CODE,
  [PurchasingGroupFieldOption.issueDate]: PurchasingGroupOrderColumn.ISSUE_DATE,
  [PurchasingGroupFieldOption.documentNumber]:
    PurchasingGroupOrderColumn.DOCUMENT_NUMBER,
};
export interface PurchaseGroupingQuery extends PageRequest {
  companyId?: number;
  supplierId?: number;
  supplierName?: string;
  orderByColumn?: PurchasingGroupOrderColumn;
}
